import { Suspense, useState } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Canvas } from '@react-three/fiber';
import tunnel from 'tunnel-rat'


import { AudioProvider } from './components/utils/AudioContext.jsx';
import Loader from "./components/utils/Loader";
import Camera from './components/utils/Camera';
import BaseScene from './components/BaseScene'
import Fog from './components/effects/Fog';
import NavBar from './components/Navbar.jsx';


import Home from './pages/Home';
import About from './pages/Context.jsx';
import Enigme from './pages/Enigme'
import Avocats from './pages/Avocats'
import Manifestants from './pages/Manifestants'
import Verdict from './pages/Verdict'
import Video from './pages/Video'
import Fresque from './pages/Fresque'




const html = tunnel()


export default function App () {
    const [showBaseScene, setShowBaseScene] = useState(false);

    const handleCameraInitialized = (initialized) => {
       setShowBaseScene(initialized);
    }

   return (
      <>
        <Suspense fallback={<Loader />}>
            <BrowserRouter>
                <AudioProvider>
                    <html.Out />
                    <Canvas flat camera={{ fov: 45, near: 0.01, far: 1000}}>
                        <color args={['#EDE9DF']} attach="background" />
                        <Fog/>
                        {showBaseScene && <BaseScene/>}
                        <Camera onCameraInitialized={handleCameraInitialized}/>
                        <html.In><About /></html.In>
                        <html.In><Enigme /></html.In>
                        <html.In><Avocats /></html.In>
                        <html.In><Manifestants /></html.In>
                        <html.In><Verdict /></html.In>
                        <html.In><Home /></html.In>
                        <html.In><Fresque /></html.In>
                        <html.In><Video /></html.In>
                        <Routes>
                            <Route path="/" element={<html.In><NavBar/></html.In>} />
                            <Route path="/context" element={<html.In><NavBar/></html.In>} />
                            <Route path="/enigme" element={<html.In><NavBar/></html.In>} />
                            <Route path="/avocats" element={<html.In><NavBar/></html.In>} />
                            <Route path="/manifestants" element={<html.In><NavBar/></html.In>} />
                            <Route path="/verdict" element={<html.In><NavBar/></html.In>} />
                            <Route path="/fresque" element={<html.In><NavBar/></html.In>} />
                            <Route path="/video" element={<html.In><NavBar/></html.In>} />
                        </Routes>
                    </Canvas>
                </AudioProvider>
            </BrowserRouter>
        </Suspense>
      </>
   );
};